/* ILS - Bonus thresholds carousel: distinguish TAP from horizontal SWIPE.
   The cards are wrapped in <a href> (whole card is a link to the bonuses
   page). The rail is a native horizontal scroller (overflow-x). Problem:
   when the user swipes the rail left/right, the finger lifts on top of a
   card and the browser fires a click on the <a>, navigating away even
   though the user only meant to scroll. Fix: on pointerdown remember the
   start X/Y; if between down and up the pointer moved more than a small
   threshold (a swipe), we suppress the click so navigation does NOT fire.
   A real tap (finger barely moved) still navigates normally. Mobile-first;
   harmless on desktop mouse (a click with no drag still works). */
(function () {
  'use strict';

  var MOVE_CANCEL = 10; // px of movement past which we treat it as a swipe, not a tap

  function setup(rail) {
    if (!rail || rail.dataset.ilsTapInit === '1') return;
    rail.dataset.ilsTapInit = '1';

    var startX = 0, startY = 0;
    var moved = false;
    var tracking = false;

    rail.addEventListener('pointerdown', function (e) {
      tracking = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });

    rail.addEventListener('pointermove', function (e) {
      if (!tracking) return;
      var dx = Math.abs(e.clientX - startX);
      var dy = Math.abs(e.clientY - startY);
      if (dx > MOVE_CANCEL || dy > MOVE_CANCEL) moved = true;
    }, { passive: true });

    rail.addEventListener('pointerup', function () {
      tracking = false;
    }, { passive: true });
    rail.addEventListener('pointercancel', function () {
      tracking = false;
      moved = false;
    }, { passive: true });

    // Click fires AFTER pointerup. If the gesture was a swipe, cancel it.
    rail.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
      moved = false;
    }, true); // capture so we intercept before the link's default
  }

  function initAll() {
    document.querySelectorAll('.shopify-section-ils-bonus .ils-bonus__rail').forEach(setup);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
